import { isSurrogate } from '../../utils/TextHelpers';
export default function isInputEmoji(event) {
  // Input events don't have a data object on all browsers
  return event.data && isSurrogate(event.data.charCodeAt(0));
}